var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.27079 14.7331C2.4761 13.492 2.0242 12.054 1.96294 10.5715C1.90168 9.08904 2.23332 7.6172 2.92277 6.3118C3.61222 5.0064 4.63381 3.91603 5.87941 3.1561C7.125 2.39617 8.54825 1.99497 9.99848 1.99497C11.4487 1.99497 12.8719 2.39617 14.1175 3.1561C15.3631 3.91603 16.3847 5.0064 17.0742 6.3118C17.7636 7.6172 18.0953 9.08904 18.034 10.5715C17.9727 12.054 17.5209 13.492 16.7262 14.7331H18.9779C19.7258 13.1733 20.0731 11.4442 19.9872 9.70896C19.9012 7.97372 19.3848 6.28946 18.4865 4.81495C17.5883 3.34043 16.3379 2.12425 14.8531 1.28103C13.3683 0.437822 11.6982 -0.00463867 10 -0.00463867C8.30185 -0.00463867 6.63166 0.437822 5.1469 1.28103C3.66213 2.12425 2.41169 3.34043 1.51346 4.81495C0.615224 6.28946 0.0987845 7.97372 0.0128224 9.70896C-0.0731398 11.4442 0.274207 13.1733 1.02212 14.7331H3.27079Z",
    fill: "#4A4AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1342 5.36938C8.66965 5.36938 6.98392 6.07646 6.06859 6.82256L6.90306 8.62225C7.63686 7.93546 8.82374 7.34857 9.89315 7.34857C10.9107 7.34857 11.4706 7.69509 11.4706 8.39748C11.4706 8.86574 11.0983 9.13421 10.3951 9.19977C7.75738 9.44795 5.70703 10.2924 5.70703 12.3637C5.70703 14.0073 6.86492 15 8.77034 15C9.34313 15.0008 9.9058 14.8454 10.4005 14.55C10.8952 14.2545 11.304 13.8296 11.585 13.3189V14.7315H13.9618V8.80955C13.9618 6.36366 12.2989 5.37563 10.1342 5.37563V5.36938ZM9.44006 13.1004C8.67728 13.1004 8.2486 12.7632 8.2486 12.2107C8.2486 11.0557 9.6216 10.7778 11.4218 10.7778C11.4218 11.9859 10.6315 13.1004 9.43853 13.1004H9.44006Z",
    fill: "#060809"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffirm);
export default __webpack_public_path__ + "static/media/affirm.fc54ec51475042223d7f5b73ed1ddf28.svg";
export { ForwardRef as ReactComponent };